export const keysToCamel = (obj, recursion = true, skipRecursionKeys = []) => {
    if (obj === undefined || obj == null)
        return obj;
    const snakeObj = obj;
    if (typeof snakeObj !== 'object') {
        return snakeObj;
    }
    if (Array.isArray(snakeObj)) {
        return snakeObj.map((i) => keysToCamel(i, recursion, skipRecursionKeys));
    }
    const entries = Object.entries(snakeObj);
    const mappedEntries = entries.map(([k, v]) => [
        toCamel(k),
        skipRecursionKeys.includes(k)
            ? v
            : recursion
                ? keysToCamel(v, recursion, skipRecursionKeys)
                : v,
    ]);
    return Object.fromEntries(mappedEntries);
};
export const toCamel = (s) => {
    return s.replace(/([-_][a-z])|([-_][0-9])/ig, ($1) => {
        return $1.toUpperCase()
            .replace('-', '')
            .replace('_', '');
    });
};
export const isArray = function (a) {
    return Array.isArray(a);
};
export const isObject = function (o) {
    return o === Object(o) && !isArray(o) && typeof o !== 'function';
};
